module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/GridItem2-1165cb4aea65c3dfe39453a187358790.webp";